import React, {useState,useEffect} from 'react';
import '../../../App.css';
import Navbar from '../../../components/Navbar';
import Banner from '../../../components/Banner';
import Footer from '../../../components/Footer';
import Reaction from '../../../components/Reaction';
import IconWhatsapp from '../../../local-assets/icon-whatsapp.png';
import IconEmail from '../../../local-assets/icon-email.png';
import ThumbsUp from '../../../local-assets/thumbs-up.png';
import ThumbsDown from '../../../local-assets/thumbs-down.png';
import BreadCrumbHome from '../../../local-assets/breadcrumb-home.png';
import Contact from '../../../components/Contact';


import LotReserveParkingBanner from '../../../local-assets/faq-detail/banner-lot-reserve-parking.svg';
import DeailPermit1 from '../../../local-assets/faq-detail/detail-permit-v1.png';
import DeailPermit2 from '../../../local-assets/faq-detail/detail-permit-v2.png';
import DeailPermit3 from '../../../local-assets/faq-detail/detail-permit-v3.png';
import DeailPermit4 from '../../../local-assets/faq-detail/detail-permit-v4.png';
import LastUpdate from '../../../components/LastUpdate';

const Index = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const renderContent = (title, subTitle, content, srcImg) => (
    <div className="flex flex-col md:flex-row gap-8 md:gap-16 mb-16 md:mb-24">
      <div className="w-full md:w-1/2 text-left">
        <p className="text-[#F36F21] font-bold text-sm mb-3">
          {title}
        </p>
        <h3 className="text-xl md:text-2xl font-bold text-[#101828] mb-4 leading-snug">
          {subTitle}
        </h3>
        <p className="text-[#475467] text-sm md:text-base leading-relaxed pr-0 md:pr-4">
          {content}
        </p>
      </div>

      {/* Kolom Kanan: Gambar */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
        {/* Background abu-abu muda membungkus gambar */}
        <div className="rounded-[2rem] w-full max-w-[480px] flex justify-center items-center">
          <img 
            src={srcImg} 
            alt={subTitle} 
            className="w-full h-auto object-contain" 
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-white min-h-screen  flex flex-col">
      <Navbar />
      <Banner
          image={process.env.REACT_APP_S3 + "banner_faq.png"} 
          beforePage="FAQ"
          currentPage="Detail FAQ" 
      />
      <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
          <div className="rounded-2xl md:rounded-3xl">
              <div className="mb-10 md:mb-16">
                  <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                      Apa keuntungan mengajukan izin & laporan di Summarecon Home Apps
                  </h1>
              </div>
              <div className="w-full">
                {renderContent(
                  "Keuntungan ke-1",
                  "Lebih cepat diatasi",
                  "Tim kami akan langsung mengatasi keluhan kamu karena aplikasi Summarecon merupakan channel utama yang kami gunakan untuk menerima keluhan",
                  DeailPermit1
                )}
                {renderContent(
                  "Keuntungan ke-2",
                  "Lihat Progress laporan dan perizinan secara langsung",
                  "Jika kamu ingin mendapatkan informasi langsung tentang perkembangan laporan dan perizinan yang kamu ajukan, cukup cek di Summarecon Home Apps",
                  DeailPermit2
                )}
                {renderContent(
                  "Keuntungan ke-3",
                  "Pengajuan laporan dan perizinan lebih fleksibel",
                  "Tenang saja pengajuan laporan & perizinan melalui Summarecon Home Apps tetap aktif sehingga kamu bisa membuat laporan & perizinan kapan saja",
                  DeailPermit3
                )}
                {renderContent(
                  "Keuntungan ke-4",
                  "Laporan & Izinmu tercatat rapi di aplikasi",
                  "Jika kamu menggunakan Summarecon Home Apps, laporan dan izin yang kamu ajukan akan tercatat rapi di aplikasi sehingga memudahkan kamu maupun tim Summarecon untuk menyelesaikan permasalahan",
                  DeailPermit4
                )}
              </div>
              <LastUpdate/>
          </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;